import { render, staticRenderFns } from "./SearchCardCollection.vue?vue&type=template&id=d433bae8&scoped=true&"
import script from "./SearchCardCollection.vue?vue&type=script&lang=js&"
export * from "./SearchCardCollection.vue?vue&type=script&lang=js&"
import style0 from "./SearchCardCollection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SearchCardCollection.vue?vue&type=style&index=1&id=d433bae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d433bae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d433bae8')) {
      api.createRecord('d433bae8', component.options)
    } else {
      api.reload('d433bae8', component.options)
    }
    module.hot.accept("./SearchCardCollection.vue?vue&type=template&id=d433bae8&scoped=true&", function () {
      api.rerender('d433bae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/SearchCardCollection.vue"
export default component.exports